export const newsData = [
  {
    id: 1,
     date: '2025.11.26',
    category: 'お知らせ',
    title: 'ウェブサイトをリニューアルいたしました',
    content: `
      ウェブサイトのリニューアルを完了しました。今後ともよろしくお願いいたします。
    `
  },
  {
    id: 2,
    date: '2025.11.26',
    category: '広告',
    title: '兵庫県三田市「三田陶芸の森。」特別日帰りツアーのご案内',
    content: `
      兵庫県三田市にある「三田陶芸の森。」が特別日帰りツアーを企画。
      世界三大青磁の一つと称される「三田青磁」。
      通常非公開の製造工程の見学や加飾、窯入れ体験。
      三田の食材とお茶をテーマにした特別料理。本格茶道体験。

      ■行程（Itinerary）

      10:00–11:30｜陶芸体験
      三田陶芸の森にて、伊藤館長（Zuihou Ito）指導による三田青磁の陶芸体験。
      通常は非公開の制作工程の見学も含まれます。

      12:00–13:30｜和食ランチ
      地元食材を使った、茶をテーマにした季節の和食コース。
      三田青磁の器で提供されます。
      ※万一ご用意できない場合は、同等内容の食事体験をご案内します。

      14:00–16:00｜茶道体験
      三田青磁の茶道具を使用した、本格的な裏千家茶道体験。
      ※会場の都合により、三田陶芸の森内のプライベート茶室で実施する場合があります。

      ■この体験に含まれるもの

      ・専属ガイド付きのプライベート1日ツアー
      ・三田青磁の陶芸ワークショップ
      ・通常非公開の制作工程への特別アクセス
      ・茶をテーマにした和食ランチコース
      ・裏千家による茶道体験
      ・三田青磁の茶器セット（お土産）
      ・制作した作品のご自宅への配送
      （完成後、約1〜2か月でお届け）

      文化的な深み、プライバシーへの配慮、そして無理のないゆったりとした行程を重視した、特別な体験をお求めの方におすすめです。
      本ツアーにご興味がございましたら、リンクより詳細をご確認ください。
    `,
    image: 'https://lxnkiipxzsdpwledlbkp.supabase.co/storage/v1/object/public/experience-images/9a3775b5-5d19-4c03-85ec-4da3bd00c03d/e9b23f71-57cc-4d09-b023-1f0debc9a524.png',
    links: [
      {
        text: '三田陶芸の森 特別日帰りツアーページ',
        url: 'https://jtc-net.co.jp/sanda-tougei-no-mori-tour2025'
      }
    ]
  },
  {
    id: 3,
    date: '2025.12.01',
    category: 'お知らせ',
    title: '合併に関するご案内',
    content: `
      このたび株式会社J・T・Cは、令和7年12月1日をもちまして株式会社カオスゲートと合併しました。株式会社カオスゲートを存続会社として新たに発足いたしました。
なお、存続会社である株式会社カオスゲートは、同日付で「株式会社J・T・C」へ商号を変更いたしました。
これにより、従来の株式会社J・T・Cの業務は新「株式会社J・T・C」が継承し、これまで同様、皆様のご期待に沿えるよう一層の努力を重ねてまいります。
また、旧株式会社J・T・Cの本社は、新会社の営業所として存続いたしますので、所在地および電話番号の変更はございません。決済業務等につきましても従前どおりお取り扱いいただけます。
今後とも倍旧のご支援とご厚誼を賜りますようお願い申し上げます。

    `,
  },
  {
    id: 4,
    date: '2025.12.17',
    category: 'お知らせ',
    title: '年末年始休業のお知らせ',
    content: `
      平素は格別のご高配を賜り、厚く御礼申し上げます。
      誠に勝手ながら、弊社では下記の期間を年末年始休業とさせていただきます。
      お客様のご理解とご協力をお願い申し上げます。 
      
      休業期間：2025年12月27日（土）〜2026年1月4日（日）
      なお、休業期間中にいただきましたお問い合わせにつきましては、2026年1月5日（月）以降、順次対応させていただきます。
      何卒よろしくお願い申し上げます。

      ※2025年12月26日（金）は時短営業いたします。ご連絡ご希望の方は午前中までにお願いいたします。
      ※休業期間中の緊急のご連絡は、担当者の携帯電話までお願いいたします。
    `,
  },
  {
    id: 5,
    date: '2026.07.16',
    category: 'お知らせ',
    title: '多言語GPS音声ガイド「AYUBITO」サイト公開のお知らせ',
    content: `
      このたび、訪日インバウンド向けの多言語GPS音声ガイド「AYUBITO（アユビト）」の紹介サイトを公開いたしました。

      AYUBITOは、観光施設・ホテル・自治体・旅行会社向けの多言語GPS音声ガイドです。
      日本語原稿からAIが多言語翻訳・音声生成・QRコード発行を行い、アプリ不要のガイド体験を簡単に提供できます。

      ・多言語対応（AI翻訳・音声生成）
      ・QRコード1つで簡単利用（アプリ不要）
      ・GPS連動で位置情報に合わせて自動再生

      ※2026年秋リリース予定です。詳しくは公式サイトをご覧ください。
    `,
    links: [
      {
        text: 'AYUBITO 公式サイト',
        url: 'https://web.ayubito.com'
      }
    ]
  },

];